import React, { useEffect } from "react";
import Navigation from "./Navigation";
import Header from "./Header";
import Footer from "./Footer";
import FooterDesc from "./FooterDesc";

const About = () => {
    useEffect(() => {
        // window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <Navigation />

            <Header />

            <section className="page-section" id="about" style={{ userSelect: "none" }}>
                <div className="container">
                    {/* <div className="text-center">
                        <h2 className="section-heading text-uppercase">About Us</h2>
                    </div> */}
                    <div className="row">
                        <div className="col-md-6 widthMedia">
                            {/* <div class="gallery"> */}
                            {/* <div className="gallery__item gallery__item--1"> */}
                            <img src="assets/img/about_img.jpg" alt="..." className="gallery__img" />
                            {/* </div> */}
                            {/* <div className="gallery__item gallery__item--4">
                                    <img src="assets/img/portfolio/nail15.jpg" alt="..." className="gallery__img" />
                                </div>
                                <div className="gallery__item gallery__item--2">
                                    <img src="assets/img/portfolio/nail7.1.jpg" alt="..." className="gallery__img" />
                                </div>
                                <div className="gallery__item gallery__item--3">
                                    <img src="assets/img/portfolio/nail8.1.jpg" alt="..." className="gallery__img" />
                                </div> */}
                            {/* </div> */}
                        </div>
                        <div className="col-md-6 widthMedia">
                            {/* <h6 className="text-muted textEffect mt-4">
                                Welcome to our Nail Studio in Surat, where creativity meets precision to redefine the art of nail care. Established in 2021, our studio is dedicated to bringing your nail fantasies to life through exquisite Nail Art, flawless Nail Extensions, all crafted by our skilled Nail Artists. 
                                <br /> <br />
                                Immerse yourself in a world of colors, patterns, and designs with our diverse Nail Art services. Our talented Nail Artists are passionate about transforming your nails into stunning masterpieces. From elegant and classic designs to bold and trendy styles, we cater to every taste, ensuring your nails become a unique canvas for self-expression.
                                <br /><br />
                                Achieve the perfect length and shape with our premium Nail Extension services. Whether you desire glamorous, long acrylic nails or a more natural look with gel extensions, our studio offers a range of options to suit your preferences. Our skilled technicians use high-quality products to ensure durability and a flawless finish, leaving you with beautiful, long-lasting nails.
                                <br /><br />
                                Meet our team of dedicated Nail Artists, each with a commitment to delivering personalized and artistic nail solutions. Trained in the latest trends and techniques, our artists bring innovation to every appointment. Whether you're looking for a simple manicure or an intricate nail design, our talented professionals are here to turn your vision into reality.
                                <br /><br />
                                Experience the epitome of nail artistry at our studio in Surat, where every stroke, extension, and design is a testament to our commitment to excellence. Book your appointment today and let us elevate your nail experience to new heights.
                                <br /><br /><br /><br />
                                <b>- MV Nails House</b>
                            </h6> */}

                            <h6 className="text-muted textEffect mt-4">
                                <span style={{ fontWeight: "bold", color: "black" }}> Welcome to MV Nails House – Where Beauty Meets Perfection! </span>
                                <br /> <br />
                                At MV Nails House, we believe that beauty begins at your fingertips. Our salon is a haven of relaxation and elegance, dedicated to providing top-tier nail care services in a warm and inviting atmosphere. From classic manicures to the latest nail art trends, we ensure that every visit leaves you feeling confident and beautiful.
                                <br /><br />
                                Our skilled professionals are passionate about nail artistry and dedicated to precision and quality. We use only high-quality, non-toxic, and long-lasting products for your safety and satisfaction. Enjoy a serene, clean, and comfortable environment that makes every appointment a rejuvenating experience.
                                <br /><br />
                                Your happiness is our priority! We tailor our services to meet your unique style and preferences. At MV Nails House, we are more than just a nail salon – we are a destination for self-care and beauty. Whether you’re preparing for a special occasion or indulging in some well-deserved pampering, we are here to make every moment special.
                                <br /><br />
                                <br /><br />
                                <b>- MV Nails House</b>
                            </h6>
                        </div>
                    </div>
                </div>
            </section >

            <FooterDesc />

            <Footer />
        </>
    )
}

export default About;